module.exports = {
      id: "video-usage",
      viewBox: "0 0 84 64",
      url: "/" + "sprite-6d93c42890617d6f6477c703e3b36dd9.svg#video",
      toString: function () {
        return this.url;
      }
    }